module.exports = __webpack_public_path__ + "assets/img/nextArrow.82631a9d.svg";